import { useEffect } from 'react';
import { useAuth, shopifyUrlParams } from '../auth';

// 把当前登录的管理员用户 ID 和店铺标识上报给 Tawk,替换掉匿名的 V1790… 访客号 ——
// 聊天面板的访客名显示这个 ID,shop_id 属性让客服知道是哪家店在咨询。
// Tawk 脚本由 index.html 异步加载,挂载时 setAttributes 可能还不存在:
// 已就绪就直接调,否则链到 onLoad(保留已有回调,支持多次调用)。
function tawkSetAttributes(attributes) {
  const api = (window.Tawk_API = window.Tawk_API || {});
  if (typeof api.setAttributes === 'function') {
    api.setAttributes(attributes);
    return;
  }
  const previous = api.onLoad;
  api.onLoad = function () {
    if (typeof previous === 'function') previous();
    api.setAttributes(attributes);
  };
}

// App Bridge 的 session token 是 JWT,payload 里的 sub 即当前管理员的
// Shopify 用户 ID。本地模式没有 token,不上线身份。
function decodeJwtPayload(token) {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

// 不渲染任何界面。
export default function TawkVisitor() {
  const { getSessionToken } = useAuth();

  useEffect(() => {
    if (!getSessionToken) return undefined;
    let cancelled = false;
    (async () => {
      const token = await getSessionToken().catch(() => null);
      const payload = token ? decodeJwtPayload(token) : null;
      const adminUserId = (payload && payload.sub) || null;
      if (cancelled || !adminUserId) return;
      // session token 的 dest 即店铺(https://xxx.myshopify.com),剥掉协议就是域名;
      // App Bridge 整页跳转后 URL 可能短暂不带 ?shop=,所以以 dest 为准、URL 兜底。
      const shopDomain =
        String(payload.dest || '').replace(/^https?:\/\//i, '') ||
        shopifyUrlParams().shop ||
        '';
      const attributes = { name: String(adminUserId) };
      if (shopDomain) attributes.shop_id = shopDomain;
      tawkSetAttributes(attributes);
    })();
    return () => { cancelled = true; };
  }, [getSessionToken]);

  return null;
}
